module.exports = __webpack_public_path__ + "static/media/arrowLeft.f4d1daf1.svg";